// project imports
import config from "../config";

// action - state management
import * as actionTypes from "./actions";

export const initialState = {
  isOpen: [], // for active default menu
  defaultId: "default",
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  opened: true,
  serviceWorkerInitialized: false,
  serviceWorkerUpdated: false,
  serviceWorkerRegistration: null,
  mapLayersOpen: false,
  mapTasksOpen: false,
  navigationOpen: false,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };

    // Service Worker
    case actionTypes.WORKER_INIT: return { ...state, serviceWorkerInitialized: true };
    case actionTypes.UPDATE_AVAILABLE: return { ...state, serviceWorkerUpdated: true, serviceWorkerRegistration: action.payload };


    // Map
    case actionTypes.MAP_LAYERS_OPEN: return { ...state, mapLayersOpen: action.payload };
    case actionTypes.MAP_TASKS_OPEN: return { ...state, mapTasksOpen: action.payload };


    case actionTypes.NAVIGATION_OPEN: return { ...state, navigationOpen: action.payload };

    default:
      return state;
  }
};

export default customizationReducer;